import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

const MaterialAlternateEmailIcon = (props) => {
  return <AlternateEmailIcon htmlColor="#1F1f1f" {...props} />;
};

export default MaterialAlternateEmailIcon;
